import { PaletteColor } from '@mui/material'

export const colors: Record<string, PaletteColor> = {
  berry: { main: '#B52C55', light: '#F6EBEE', dark: '#8C2242', contrastText: '#FFFFFF' },
  dragonFruit: { main: '#FF2869', light: '#FF5B8D', dark: '#F4004A', contrastText: '#FFFFFF' },
}
